import React from 'react';

function Tenders() {
  const banks = [
    { name: 'Сбербанк', accounts: 'казначейские счета для 44-ФЗ, 223-ФЗ', url: 'https://www.sberbank.ru/ru/legal/tenders' },
    { name: 'ВТБ', accounts: 'спецсчета для госзакупок, гарантии', url: 'https://www.vtb.ru/business/tendery/' },
    { name: 'ПСБ', accounts: 'казначейское сопровождение ГОЗ', url: 'https://www.psbank.ru/Business/Treasury' },
  ];

  const platforms = [
    { name: 'Сбербанк-АСТ', url: 'https://www.sberbank-ast.ru' },
    { name: 'РТС-тендер', url: 'https://www.rts-tender.ru' },
    { name: 'ЕЭТП (Росэлторг)', url: 'https://www.roseltorg.ru' },
    { name: 'ЭТП ГПБ', url: 'https://etp.gpb.ru' },
    { name: 'НАЭТ (TEK-Torg)', url: 'https://www.tektorg.ru' },
  ];

  return (
    <div>
      <h2>Тендеры и казначейские счета</h2>
      <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4, marginBottom: 16 }}>
        Открытие казначейских счетов для госзакупок (44-ФЗ, 223-ФЗ, 615-ПП)
      </p>

      <div style={{ marginBottom: 20, padding: 14, background: '#1E293B', borderRadius: 8, border: '1px solid #334155' }}>
        <h3 style={{ marginBottom: 8 }}>Как участвовать в тендерах</h3>
        <ol style={{ color: '#94A3B8', fontSize: 13, paddingLeft: 20 }}>
          <li style={{ marginBottom: 4 }}>Получите электронную подпись (УКЭП)</li>
          <li style={{ marginBottom: 4 }}>Зарегистрируйтесь на торговой площадке</li>
          <li style={{ marginBottom: 4 }}>Откройте казначейский счёт в банке</li>
          <li style={{ marginBottom: 4 }}>Внесите обеспечение заявки (0,5–5% от контракта)</li>
          <li>Подайте заявку и участвуйте</li>
        </ol>
      </div>

      <h3 style={{ marginBottom: 10 }}>Банки с казначейскими счетами</h3>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, marginBottom: 20 }}>
        <thead>
          <tr style={{ color: '#94A3B8', textAlign: 'left' }}>
            <th style={{ padding: 8 }}>Банк</th>
            <th style={{ padding: 8 }}>Услуги</th>
            <th style={{ padding: 8 }}>Ссылка</th>
          </tr>
        </thead>
        <tbody>
          {banks.map((b, i) => (
            <tr key={i} style={{ borderBottom: '1px solid #334155' }}>
              <td style={{ padding: 8 }}>{b.name}</td>
              <td style={{ padding: 8, color: '#94A3B8' }}>{b.accounts}</td>
              <td style={{ padding: 8 }}>
                <a href={b.url} target="_blank" rel="noopener noreferrer" style={{ color: '#6366F1', textDecoration: 'none' }}>
                  Открыть →
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <h3 style={{ marginBottom: 10 }}>Торговые площадки</h3>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
        <thead>
          <tr style={{ color: '#94A3B8', textAlign: 'left' }}>
            <th style={{ padding: 8 }}>Площадка</th>
            <th style={{ padding: 8 }}>Ссылка</th>
          </tr>
        </thead>
        <tbody>
          {platforms.map((p, i) => (
            <tr key={i} style={{ borderBottom: '1px solid #334155' }}>
              <td style={{ padding: 8 }}>{p.name}</td>
              <td style={{ padding: 8 }}>
                <a href={p.url} target="_blank" rel="noopener noreferrer" style={{ color: '#6366F1', textDecoration: 'none' }}>
                  Перейти на площадку →
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Tenders;